// extracted by mini-css-extract-plugin
export default {"msg_container":"raa","message":"saa","show":"taa","fromRD":"uaa","fromCustomer":"vaa","note":"waa","loading":"xaa","image":"yaa","initials":"zaa","input_wrapper":"Aaa","input":"Baa"};
    if(module.hot) {
      // 1715632479628
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  